import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { KEY_CONTENT_ROUTES } from '../../routing';
import HowItWorksGirlIcon from 'components/IconModule/icons/howItWorksGirl';
import HowItWorksBookLessonIcon from 'components/IconModule/icons/howItWorksBookLesson';
import HowItWorksPayLessonIcon from 'components/IconModule/icons/howItWorksPayLesson';
import HowItWorksTrackGoalsIcon from 'components/IconModule/icons/howItWorksTrackGoals';
import HowItWorksGetFeedbackIcon from 'components/IconModule/icons/howItWorksGetFeedback';
import HowItWorksLeaveReviewIcon from 'components/IconModule/icons/howItWorksLeaveReview';
import HowItWorksContactUsIcon from 'components/IconModule/icons/howItWorksContactUs';
import PhoneIcon from 'components/IconModule/icons/phone';
import MailIcon from 'components/IconModule/icons/mail';
import {
  RequestTutorModal,
  RequestTutorSuccessModal
} from 'components/ModalsModule';
import Heading from './components/Heading';
import Card from './components/Card';
import css from './HowItWorks.module.scss';
import { useTranslation } from 'react-i18next';
import { isUAE } from 'utils/env';
import { saveCountry, saveLevel, saveSubject } from 'utils/useSessionStorage';
export default function HowItWorks() {
  const [isRequestTutorModalVisible, setIsRequestTutorModalVisible] = useState(
    false
  );
  const [
    isRequestTutorSuccessModalVisible,
    setIsRequestTutorSuccessModalVisible
  ] = useState(false);

  const { t } = useTranslation()

  return (
    <div className={css.wrapper}>
      <Heading />
      <div className={css.title}>{t('How it Works')}</div>
      <div className={css.descriptionBlock}>
        <div className={css.topBlock}>
          <div className={css.top}>
            <Card number={1} title={t("Browse all Tutors")}>
              {t('Use our inbuilt filters to narrow down your search to find the tutor you feel will best suit your needs')}
            </Card>
            <div className={cn(css.or, css.mobile)}>or</div>
            <Card number={1} title={t("Match me with a Tutor")}>
              {t('Let us do the hard work for you! Use the ‘Match me with a Tutor’ option and')}&nbsp;
              <span className={css.boldText}>
                {t('get matched with suitable tutors for free!')}
              </span>
            </Card>
          </div>
          <div className={cn(css.topBorderBlock, css.desktop)}>
            <div className={cn(css.circle, css.leftCircle)} />
            <div className={cn(css.circle, css.rightCircle)} />
          </div>
        </div>
        <div className={cn(css.bottomBlock, css.desktop)}>
          <div className={css.descriptionBottomBlock}>
            <Card number={2} title={t("Book a Free Trial Call")}>
              <HowItWorksGirlIcon className={css.icon} />
              <div className={css.paragraph}>
                {t('Pick a suitable time for a')}{' '}
                <span className={css.boldText}>{t('15 minute Free Trial Call')}</span>{' '}
                {t('to virtually meet your tutor and see if they are right for you')}
              </div>
              <div className={css.paragraph}>
                {t('Once you have completed a Trial Call and you are happy with your choice you can go on to')}{' '}
                <span className={css.boldText}>
                  {t('book as many lessons as you like')}
                </span>{' '}
                {t('with them')}.{' '}
              </div>
              <div className={cn(css.pinkText, css.paragraph)}>
                {t('Message your Tutor')}
              </div>
              <div className={css.paragraph}>
                {t('You can also')}{' '}
                <span className={css.boldText}>{t('message your tutor')}</span>
                 {t('of choice and ask about any questions you may have before booking')}
              </div>
            </Card>
            <Card number={4} title={t("Pay for your Lessons")}>
              <div className={css.paragraph}>
                <span className={css.boldText}>{t('Bulk buy')}</span> {t('or')}{' '}
                <span className={css.boldText}>{t('pay-as-you-go')}</span>, {t('using our')}{' '}
                <span className={css.boldText}>{t('secure online payment')}</span>{' '}
                {t('system Stripe')}.
              </div>
              <div className={css.paragraph}>
                {t('Keep an eye out for our')}{' '}
                <span className={css.boldText}>{t('discount codes')}</span> {t('and')}{' '}
                <span className={css.boldText}>{t('package deal offers!')}</span>
              </div>
              <HowItWorksPayLessonIcon className={css.icon} />
            </Card>
            <div className={css.marginTop}>
              <Card number={6} title={t("Get Lesson Feedback")}>
                <HowItWorksGetFeedbackIcon className={css.icon} />
                <div className={css.paragraph}>
                  {t('After your lesson')}{' '}
                  <span className={css.boldText}>
                    {t('your tutor will give you feedback')}
                  </span>{' '}
                  {t('with tips, advice and areas to work on for next time')}
                </div>
              </Card>
            </div>
          </div>
          <div className={cn(css.middleBorderBlock, css.desktop)}>
            <div className={cn(css.circle, css.topCircle)} />
            <div className={cn(css.circle, css.topCircle2)} />
            <div className={cn(css.circle, css.topCircle3)} />
            <div className={cn(css.circle, css.topCircle4)} />
            <div className={cn(css.circle, css.topCircle5)} />
            <div className={cn(css.circle, css.topCircle6)} />
          </div>
          <div className={css.descriptionBottomBlock}>
            <div className={css.marginTop}>
              <Card number={3} title={t("Book your Lessons")}>
                <div className={css.paragraph}>
                  {t('Whether you choose to')}{' '}
                  <span className={css.boldText}>{t('pay-as-you-go')}</span> {t('or')}{' '}
                  <span className={css.boldText}>{t('bulk book')}</span> {t('lessons')},
                  {t('select dates and times that suit you')}
                </div>
                <div className={css.paragraph}>
                  {t('Get')} <span className={css.boldText}>{t('discounts')}</span> {t('when you')}{' '}
                  <span className={css.boldText}>{t('book 10 lessons or more')}</span>{' '}
                  {t('with our package deal offers!')}
                </div>
                <HowItWorksBookLessonIcon className={css.icon} />
              </Card>
            </div>
            <div className={css.marginTop}>
              <Card number={5} title={t("Track your Goals")}>
                <HowItWorksTrackGoalsIcon className={css.icon} />
                <div className={css.paragraph}>
                  {t('Whether you’re aiming for a particular grade or just looking to improve your skills you can')}{' '}
                  <span className={css.boldText}>{t('set and track your goals')}</span>{' '}
                  {t('on your dashboard')}.{' '}
                </div>
              </Card>
            </div>
            <div className={css.cardMargin}>
              <Card number={7} title={t("Leave your Tutor a Review")}>
                <div className={css.paragraph}>
                  {t('After your lesson')}{' '}
                  <span className={css.boldText}>
                    {t('leave your tutor a review!')}
                  </span>{' '}
                  {t('Our tutors really do appreciate your feedback Your reviews help them receive more bookings!')}
                </div>
                <div className={cn(css.pinkText, css.paragraph)}>
                  {t('Review us on Trust Pilot or Google')}{' '}
                </div>
                <div className={css.paragraph}>
                  {t('We always appreciate every review we get Writing us a quick review on either')}{' '}
                  <span className={css.boldText}>{t('Trust Pilot')}</span> {t('or')}{' '}
                  <span className={css.boldText}>{t('Google Reviews')}</span> {t('can help')}
                  {t('others find their perfect tutor too!')}
                </div>
                <HowItWorksLeaveReviewIcon className={css.icon} />
              </Card>
            </div>
          </div>
        </div>
        <div className={cn(css.mobile, css.mobileList)}>
          <Card number={2} title={t("Book a Free Trial Call")}>
            <div className={css.paragraph}>
              {t('Pick a suitable time for a')}{' '}
              <span className={css.boldText}>{t('15 minute Free Trial Call')}</span>
              {' '}{t('to virtually meet your tutor and see if they are right for you')}
            </div>
            <HowItWorksGirlIcon className={css.icon} />
            <div className={css.paragraph}>
              {t('Once you have completed a Trial Call and you are happy with your choice you can go on to')}{' '}
              <span className={css.boldText}>
                {t('book as many lessons as you like')}
              </span>{' '}
              {t('with them')}.{' '}
            </div>
            <div className={cn(css.pinkText, css.paragraph)}>
              {t('Message your Tutor')}
            </div>
            <div className={css.paragraph}>
              {t('You can also')}{' '}
              <span className={css.boldText}>{t('message your tutor')}</span>
              { }{t('of choice and ask about any questions you may have before booking')}
            </div>
          </Card>
          <Card number={3} title={t("Book your Lessons")}>
            <div className={css.paragraph}>
              {t('Whether you choose to')}{' '}
              <span className={css.boldText}>{t('pay-as-you-go')}</span> {t('or')}{' '}
              <span className={css.boldText}>{t('bulk book')}</span> {t('lessons, select dates and times that suit you')}
            </div>
            <div className={css.paragraph}>
              {t('Get')} <span className={css.boldText}>{t('discounts')}</span> {t('when you')}{' '}
              <span className={css.boldText}>{t('book 10 lessons or more')}</span> {t('with our package deal offers!')}
            </div>
            <HowItWorksBookLessonIcon className={css.icon} />
          </Card>
          <Card number={4} title={t("Pay for your Lessons")}>
            <div className={css.paragraph}>
              <span className={css.boldText}>{t('Bulk buy')}</span> {t('or')}{' '}
              <span className={css.boldText}>{t('pay-as-you-go')}</span>, {t('using our')}{' '}
              <span className={css.boldText}>{t('secure online payment')}</span> {t('system Stripe')}.
            </div>
            <HowItWorksPayLessonIcon className={css.icon} />
            <div className={css.paragraph}>
              {t('Keep an eye out for our')}{' '}
              <span className={css.boldText}>{t('discount codes')}</span> {t('and')}{' '}
              <span className={css.boldText}>{t('package deal offers!')}</span>
            </div>
          </Card>
          <Card number={5} title={t("Track your Goals")}>
            <div className={css.paragraph}>
              {t('Whether you’re aiming for a particular grade or just looking to improve your skills you can')}{' '}
              <span className={css.boldText}>{t('set and track your goals')}</span> {t('on your dashboard')}.{' '}
            </div>
            <HowItWorksTrackGoalsIcon className={css.icon} />
          </Card>
          <Card number={6} title={t("Get Lesson Feedback")}>
            <HowItWorksGetFeedbackIcon className={css.icon} />
            <div className={css.paragraph}>
              {t('After your lesson')}{' '}
              <span className={css.boldText}>
                {t('your tutor will give you feedback')}
              </span>{' '}
              {t('with tips, advice and areas to work on for next time')}
            </div>
          </Card>
          <Card number={7} title={t("Leave your Tutor a Review")}>
            <div className={css.paragraph}>
              {t('After your lesson')}{' '}
              <span className={css.boldText}>{t('leave your tutor a review!')}</span>{' '}
              {t('Our tutors really do appreciate your feedback Your reviews help them receive more bookings!')}
            </div>
            <div className={cn(css.pinkText, css.paragraph)}>
              {t('Review us on Trust Pilot or Google')}{' '}
            </div>
            <div className={css.paragraph}>
              {t('We always appreciate every review we get Writing us a quick review on either')} <span className={css.boldText}>{t('Trust Pilot')}</span>{' '}
              {t('or')} <span className={css.boldText}>{t('Google Reviews')}</span> {t('can help others find their perfect tutor too!')}
            </div>
            <HowItWorksLeaveReviewIcon className={css.icon} />
          </Card>
        </div>
      </div>
      <div className={css.bottomBlockLinks}>
        <div className={css.title}>{t('Let’s Get Started!')}</div>
        <div className={css.heroLinks}>
          <Link className="btn-home" to={KEY_CONTENT_ROUTES.SEARCH_RESULTS} onClick={() => {
              saveSubject("0");
              saveLevel("0");
              saveCountry("0");
            }}
          >
            {t('Browse All Tutors')}
          </Link>
          {!isUAE&&<Link
            className="btn-home-transparent"
            to={KEY_CONTENT_ROUTES.POST_JOB}
          >
            {t('Match me with a Tutor')}
          </Link>}
        </div>
      </div>
      {!isUAE&&<div className={css.contactUsBlock}>
        <div className={css.contactInfo}>
          <div className={cn(css.pinkText, css.titleText)}>
            {t('Get in touch with the team')}
          </div>
          <div className={css.contactHelperText}>
            {t('Remember, if you have any trouble or need any assistance, we’re here to help!')}
          </div>
          <button
            className={cn('btn-primary', css.askBtn)}
            onClick={() => setIsRequestTutorModalVisible(true)}
          >
            {t('Ask an Expert')}
          </button>
          <div className={css.contacts}>
            <MailIcon className={css.contactIcons} />
            <span className={css.contactLink}>info@tutorhouse.co.uk</span>
          </div>
          <div className={css.contacts}>
            <PhoneIcon className={css.contactIcons} />
            <span className={css.contactLink}>+4420 3950 0320</span>
          </div>
        </div>
        <HowItWorksContactUsIcon className={cn(css.bottomImg)} />
      </div>}
      <div className={css.bottomTutorBlock}>
        <div className={css.footerText}>
          {t('Tutor House only accepts the')}{' '}
          <span className={css.hightLight}>{t('top 20%')}</span> {t('of applicants to become')} <span className={css.hightLight}>{t('tutors')}</span> {t('with us')}
        </div>
        {!isUAE&&<div className={css.bottomBtn}>
          <Link
            className={cn('btn-home', css.browseTutorLink)}
            to={KEY_CONTENT_ROUTES.SEARCH_RESULTS}
            onClick={() => {
              saveSubject("0");
              saveLevel("0");
              saveCountry("0");
            }}
          >
            {t('Browse All Tutors')}
          </Link>
          <Link
            className="btn-home-transparent"
            to={KEY_CONTENT_ROUTES.POST_JOB}
          >
            {t('Match me with a Tutor')}
          </Link>
        </div>}
      </div>
      <RequestTutorModal
        visible={isRequestTutorModalVisible}
        onCancel={() =>
          setIsRequestTutorModalVisible(!isRequestTutorModalVisible)
        }
        onSuccess={() => {
          setIsRequestTutorModalVisible(false);
          setIsRequestTutorSuccessModalVisible(true);
        }}
      />

      <RequestTutorSuccessModal
        visible={isRequestTutorSuccessModalVisible}
        onSuccess={() =>
          setIsRequestTutorSuccessModalVisible(
            !isRequestTutorSuccessModalVisible
          )
        }
      />
    </div>
  );
}
